import React from 'react';
import { ROOT_URL } from '../../config';

import Face from '../../img/face.png';
import Pint from '../../img/pint.png';
import Google from '../../img/google.png';
import Insta from '../../img/insta.png';

export const SocialMedia = () => {
  return(
    <div className="row col-4 no-flow nop social-media">
      <a href={`http://www.facebook.com/sharer.php?u=${window.location.href}`} target="_blank">
        <div className="col-1 column nop"><img src={Face} /></div>
      </a>
      <a href={`javascript:void((function()%7Bvar%20e=document.createElement('script');e.setAttribute('type','text/javascript');e.setAttribute('charset','UTF-8');e.setAttribute('src','http://assets.pinterest.com/js/pinmarklet.js?r='+Math.random()*99999999);document.body.appendChild(e)%7D)());`} target="_blank">
        <div className="col-1 column nop"><img src={Pint} /></div>
      </a>
    </div>
  );
}

export const SocialMedia2 = (props) => {
  return(
    <div className="row col-12 social-media no-flow">
      <a
        href={`http://www.facebook.com/sharer.php?u=${window.location.href}`} target="_blank">
        <div className="col-3 column nop"><img src={Face} /></div>
      </a>
      <a href={`javascript:void((function()%7Bvar%20e=document.createElement('script');e.setAttribute('type','text/javascript');e.setAttribute('charset','UTF-8');e.setAttribute('src','http://assets.pinterest.com/js/pinmarklet.js?r='+Math.random()*99999999);document.body.appendChild(e)%7D)());`} target="_blank">
        <div className="col-3 column nop"><img src={Pint} /></div>
      </a>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/reusable/social-media.js